import { inject, injectable } from 'inversify'
import type { PaginationUrlFilterScalarValueType } from '@/services/tables/types'
import { type FilterToFormattedTextConvertable, type FormattedTextNode, FilterOperationEnum } from '@/services/types'
import { isTFilterRangeEnd, isTFilterRangeFull, isTFilterRangeStart } from '@/services/filters/types'
import type TranslateService from '@/services/translateService'
import { SERVICE_TYPES } from '@/core/container/types'
import { coersceBoolean } from '@/utils/boolean/coersceBoolean'
import { mapFilterToRange } from '@/services/filters/mapFilterToRange'

@injectable()
export default class NumericFilterMapper implements FilterToFormattedTextConvertable {
  constructor(@inject(SERVICE_TYPES.TranslateService) protected readonly translateService: TranslateService) {}

  public toFormattedText(filterValue: PaginationUrlFilterScalarValueType): FormattedTextNode[] {
    const isEmpty = filterValue[FilterOperationEnum.isEmpty]
    if (isEmpty !== undefined && isEmpty !== null) {
      return [
        {
          type: 'italic',
          value: coersceBoolean(isEmpty, true, false)
            ? this.translateService.t('tmFilterNumeric.empty')
            : this.translateService.t('tmFilterNumeric.notEmpty'),
        },
      ]
    }
    const range = mapFilterToRange(filterValue)
    if (!range) return []

    if (isTFilterRangeFull(range)) {
      return [
        {
          type: 'italic',
          value: this.translateService.t('tmFilterNumeric.between'),
        },
        {
          type: 'badge',
          value: `${range.start} - ${range.end}`,
        },
      ]
    }
    if (isTFilterRangeStart(range)) {
      return [
        '≥',
        {
          type: 'badge',
          value: range.start,
        },
      ]
    }
    if (isTFilterRangeEnd(range)) {
      return [
        '≤',
        {
          type: 'badge',
          value: range.end,
        },
      ]
    }

    return []
  }
}
